export default "__VITE_ASSET__DgoSDnB6__"